import { useState, useEffect } from 'react';
import { IonSearchbar, IonList, IonItem, IonInput, IonModal, IonIcon, IonImg } from '@ionic/react';
import { close, earthOutline } from 'ionicons/icons';
import { Storage } from '@capacitor/storage';
import './Nationality.css';
import Loading from '../../Loading';
import warningSign from '../../../assets/images/warning.svg';

interface Props {
    nationalityParentCallback: Function,
    inputValue: any
}
function handleInput(event: any) {
    const list = document.querySelector('.nationality-modal-items') as any;
    const items = Array.from(list.children) as any;
    const query = event.target.value.toLowerCase();
    requestAnimationFrame(() => {
        items.forEach((item: any) => {
            const shouldShow = item.textContent.toLowerCase().indexOf(query) > -1;
            item.style.display = shouldShow ? 'block' : 'none';
        });
    });
}
const Nationality = (props: Props) => {
    const [state, setState] = useState({
        showNationalityModal: false,
        searchText: '',
        errorMessage: ''
    });
    const [countries, setCountries] = useState({}) as any;
    useEffect(() => {
        const getCountries = async () => {
            const { value } = await Storage.get({ key: 'countries' });
            if (value) {
                const objectValue = JSON.parse(value);
                setCountries(objectValue);
            } else {
                setCountries({});
            }
        }
        if (state.showNationalityModal) {
            getCountries();
        }
    }, [state.showNationalityModal])
    useEffect(() => {
        if (Object.keys(countries).length !== 0) {
            const searchbar = document.querySelector('.nationality-modal-searchbar') as any;
            if (searchbar) {
                searchbar.addEventListener('ionInput', handleInput);
            }
        }
    }, [countries]);
    const onItemClick = (value: any) => {
        setState(prevState => ({ ...prevState, showNationalityModal: false }));
        props.nationalityParentCallback(value);
    };
    return (
        <>
            <IonModal isOpen={state.showNationalityModal} onDidDismiss={() => setState({ ...state, showNationalityModal: false })} mode="ios">
                <div className="nationality-modal-content">
                    <h3 className="nationality-modal-title">
                        ملیت خود را انتخاب کنید
                        <IonIcon icon={close} onClick={() => setState({ ...state, showNationalityModal: false })} />
                    </h3>
                    {state.errorMessage.trim() !== '' ? (
                        <div className="box-error">
                            <IonImg src={warningSign} />
                            <p>{state.errorMessage}</p>
                        </div>
                    ) :
                        <>
                            <IonSearchbar
                                className="nationality-modal-searchbar"
                                value={state.showNationalityModal ? state.searchText : ''}
                                onIonChange={e => setState({ ...state, searchText: e.detail.value! })}
                                autocomplete="on"
                                showCancelButton="never"
                                showClearButton="always"
                                placeholder=""
                                mode="ios"
                                disabled={Object.keys(countries).length === 0 ? true : false}

                            ></IonSearchbar>
                            {Object.keys(countries).length !== 0 ?
                                <IonList className="nationality-modal-items">
                                    {Object.values(countries).map((item: any, index: number) =>
                                        <IonItem key={"index" + index} onClick={() => onItemClick(item)}>
                                            {item.name}
                                            <IonIcon icon={earthOutline} />
                                        </IonItem>
                                    )}
                                </IonList>
                                :
                                <Loading />
                            }
                        </>
                    }
                </div>
            </IonModal>
            <IonInput type="text" onClick={() => setState({ ...state, showNationalityModal: true })} value={props.inputValue.name} readonly />
        </>
    );
};

export default Nationality;
